module.exports = function () {
  return new Worker(__webpack_public_path__ + "e416d8e3320b7747669c.worker.js");
};